export default "{\n    \"message\": \"Está actuando como {{name}}\",\n    \"exitButton\": \"Salir\"\n}\n"